<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p><span><i>To my father, Donald B. Straus A pioneer in the field</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?e3f0b328